import React, { useState, useEffect, useContext } from 'react'
import './search-menu.less'
import { Input } from 'bimui';
import { ReactComponent as SearchSvg } from './icons/search.svg';
import classNames from 'classnames';
import { SystemContext } from '@/App';
export interface Category {
    name: string
    items: any[]
}

interface IProps {
    categories: Category[]
    onItemClick: (itemId: number) => void; // 点击菜单项时的回调
}

export default function SearchMenu(props: IProps) {
    const systemContext = useContext(SystemContext); // 获取全局状态
    const { activeMonitorObjectId, setActiveMonitorObjectId, showMObjectLabelDetailList, setShowMObjectLabelDetailList } = systemContext;

    /**
     * 存储搜索框内容
     */
    const [sectionName, setSectionName] = useState<string>('');

    const [selectedCategory, setSelectedCategory] = useState<string>('构件'); // 当前选中的类别
    const [filteredItems, setFilteredItems] = useState<{ id: number, name: string }[]>([]); // 过滤后的数据

    const [selectedItem, setSelectedItem] = useState<number>(null); // 当前选中的id

    // 同步全局的 activeMonitorObjectId 到 selectedItem
    useEffect(() => {
        if (activeMonitorObjectId) {
            setSelectedItem(activeMonitorObjectId); // 将activeMonitorObjectId赋值给selectedItem
        }
    }, [activeMonitorObjectId]);

    /**
     * 更新搜索框中的名称的状态、根据输入内容筛选选择列表。
     * @param e 输入事件。
     */
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim(); // 获取输入值并去掉两端空格
        setSectionName(value); // 更新输入框状态
        // 过滤符合搜索条件的对象
        const currentCategory = props.categories?.find(cat => cat.name === selectedCategory);
        const filtered = currentCategory?.items.filter(item => item.name.toLowerCase().includes(value)) || [];
        setFilteredItems(filtered); // 更新显示的筛选结果
    };

    /**
     * 处理左侧类别的点击
     * @param categoryName 选择的对象类型
     */
    const handleCategoryClick = (categoryName: string) => {
        setSelectedCategory(categoryName);
        setSectionName(''); // 清空搜索框内容
        const category = props.categories?.find(cat => cat.name === categoryName);
        setFilteredItems(category?.items || []);
    };

    /**
     * 初始化与切换类型获取列表
     */
    useEffect(() => {
        const category = props.categories?.find(cat => cat.name === selectedCategory);
        setFilteredItems(category?.items || []); // 初始化或更新 filteredItems
    }, [selectedCategory]);

    /**
     * 处理右侧具体对象的选择
     * @param itemId 选择的对象id
     */
    const handleItemClick = (itemId: number) => {
        // 如果点击了已经选中的项，取消选择
        if (selectedItem === itemId) {
            setSelectedItem(null); // 取消选择
            setActiveMonitorObjectId(null); // 更新全局的 activeMonitorObjectId
        } else {
            setSelectedItem(itemId); // 选择新的项
            setActiveMonitorObjectId(itemId); // 更新全局的 activeMonitorObjectId
        }
        if (!showMObjectLabelDetailList.includes(itemId)) {
            setShowMObjectLabelDetailList([
                ...showMObjectLabelDetailList,
                itemId
            ])
        }
    };

    return (
        <div className='search-menu-container'>
            <div className="input-with-icon">
                <input
                    className="search-input" // 自定义样式
                    type="text"
                    value={sectionName}
                    onChange={handleNameChange}
                    autoFocus={true}
                />
                <span className="input-icon" onClick={() => { }}>
                    <SearchSvg />
                </span>
            </div>

            <div className='search-modal-body'>
                <div className='body-left'>
                    {props.categories?.map((category) => (
                        <div
                            key={category.name}
                            className={classNames({
                                "category-left": true,
                                "category-active": selectedCategory === category.name,
                            })}
                            onClick={() => handleCategoryClick(category.name)}
                        >
                            {category.name}
                        </div>
                    ))}
                </div>

                <div className='body-right'>
                    {filteredItems.length > 0 ? (
                        filteredItems.map(item => (
                            <div
                                key={item.id}
                                className={classNames("category-right", {
                                    "category-selected": selectedItem === item.id,
                                })}
                                onClick={() => handleItemClick(item.id)}
                            >
                                {item.name}
                            </div>
                        ))
                    ) : (
                        <div className='body-right-null'>没有找到相关数据</div>
                    )}
                </div>
            </div>

            {/* 分割线 */}
            <div className="vertical-line"></div>
        </div>
    );
}
